module.exports = __webpack_public_path__ + "img/new_38.fd78c96b.jpg";